<div
  id="dashboard"
  class="page-layout blank"
  class="page-layout simple"
  fxLayout="column">
  <!-- HEADER -->
  <div
    class="header"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayout.gt-sm="row"
    fxLayoutAlign.gt-sm="space-between end">
    <div
      class="name"
      [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
      {{ 'GENERAL.TITLE.DASHBOARD' | translate }}
    </div>
    <div class="center option" fxLayout="row">
      <div>
        <button (click)="changeDisplay(0)" mat-icon-button class="display-btn">
          <mat-icon>grid_view</mat-icon>
        </button>
        <button (click)="changeDisplay(1)" mat-icon-button class="display-btn">
          <mat-icon>view_compact</mat-icon>
        </button>
        <button (click)="changeDisplay(2)" mat-icon-button class="display-btn">
          <mat-icon>view_list</mat-icon>
        </button>
      </div>
      <div fxFlex fxLayout="row" fxLayoutAlign="start center">
        <!-- SEARCH -->
        <div class="search-wrapper">
          <div
            class="search"
            fxFlex
            fxLayout="row"
            fxLayoutAlign="start center">
            <mat-icon>search</mat-icon>
            <input
              #servicefilter
              matInput
              [(ngModel)]="searchText"
              (keyup)="applyFilter($event)"
              autoComplete="on" />
          </div>
        </div>
        <!-- / SEARCH -->
        <div
          class="reset-menu"
          fxFlex
          fxLayout="row"
          fxLayoutAlign="start center">
          <button
            mat-icon-button
            [matMenuTriggerFor]="reset"
            class="display-btn">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #reset="matMenu">
            <button mat-menu-item (click)="confirmReset()">
              <span>{{ 'DASHBOARD.FAVORITE.RESET' | translate }}</span>
              <mat-icon>build</mat-icon>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  </div>
  <!-- / HEADER -->

  <!-- CONTENT -->
  <div class="content-card" fxFill>
    @if (isLoading) {
      <mat-progress-bar
        color="accent"
        mode="indeterminate"
        class="mat-progress-bar"></mat-progress-bar>
    }
    @if (!isLoading && selectedUser) {
      <div class="content">
        @for (message of maintenanceMessage; track message) {
          <div>
            @if (currentLang === 'fr') {
              <div class="row wrap">
                <div class="message-box {{ message.color }}">
                  <div class="row wrap title_maintenance">
                    {{ message.titre_fr }}
                  </div>
                  <div>{{ message.texte_fr }}</div>
                </div>
              </div>
            }
            @if (currentLang === 'de') {
              <div class="row wrap">
                <div class="message-box {{ message.color }}">
                  <div class="row wrap title_maintenance">
                    {{ message.titre_de }}
                  </div>
                  <div>{{ message.texte_de }}</div>
                </div>
              </div>
            }
          </div>
        }
        @if (mustChangemail) {
          <div class="message-box warning margin12">
            {{ 'ERROR.EMAILUPDATE' | translate }}
            <button
              mat-raised-button
              matStepperNext
              type="button"
              color="accent"
              class="change"
              (click)="goToIddentity()">
              {{ 'ERROR.NAMEUPDATEBTN' | translate }}
            </button>
          </div>
        }
        @if (!isSuccess && error) {
          <div>
            <div class="row wrap">
              <div class="message-box error user-created">
                <app-error-message [error]="error.error" />
              </div>
            </div>
          </div>
        }
        @if (display === 0 || display === 1) {
          <div>
            @if (getFavoriteServices().length >= 1) {
              <mat-card class="card-container">
                <h2 class="expand-hidden">
                  {{ 'DASHBOARD.FAVORITE.TITLE' | translate }}
                </h2>
                @if (display === 0) {
                  <div fxLayout="row wrap" fxLayoutGap="15px">
                    @for (
                      service of getFavoriteServices() | filter: searchText;
                      track service
                    ) {
                      <div class="app-card">
                        <div
                          class="image-description"
                          fxLayoutAlign="left center">
                          <div fxFlex="100">
                            @if (service.jpegPhoto !== '') {
                              <img
                                [src]="
                                  service.jpegPhoto.includes(
                                    '/assets/images/maintenance/services/'
                                  )
                                    ? service.jpegPhoto
                                    : 'data:image/png;base64,' +
                                      service.jpegPhoto
                                "
                                class="serviceImage"
                                alt="{{
                                  'GENERAL.SERVICE_IMAGE' | translate
                                }}" />
                            } @else {
                              <img
                                src="../../../assets/images/cards/noimage.png"
                                class="serviceImage"
                                alt="{{ 'GENERAL.EMPTY_IMAGE' | translate }}" />
                            }
                          </div>
                        </div>
                        <div class="favorite-menu-maxi">
                          <button mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                          </button>
                          <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="removeTag(service)">
                              <span>{{
                                'DASHBOARD.REMOVEFAVORITE' | translate
                              }}</span>
                              <mat-icon>star_border</mat-icon>
                            </button>
                          </mat-menu>
                        </div>
                        <div>
                          <div class="title-container">
                            <div class="title">{{ service.title }}</div>
                            <div class="subtitle secondary-text">
                              {{ service.subtitle }}
                            </div>
                          </div>
                          <div class="description">
                            <div class="serviceDesc" fxFlex="100">
                              {{ service.description }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="action"
                          fxLayout="row"
                          fxLayoutAlign="start center">
                          <button
                            mat-button
                            color="accent"
                            class="access-btn"
                            (click)="openService(service)">
                            {{ 'GENERAL.ACCESS' | translate }}
                          </button>
                          @if (service.help !== '') {
                            <button
                              mat-button
                              color="accent"
                              (click)="openDocumentation(service)">
                              <mat-icon mat-list-icon>help_outline</mat-icon>
                            </button>
                          }
                          <div fxFlex></div>
                          <!-- Spacer to push the image to the right -->
                          @if (service.subtype.includes('pedagogique-edulog')) {
                            <div fxLayoutAlign="end center">
                              <img
                                [src]="
                                  '../../../assets/images/cards/edulog.png'
                                "
                                class="image-edulog"
                                alt="{{
                                  'GENERAL.SERVICE_IMAGE' | translate
                                }}" />
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (display === 1) {
                  <div fxLayout="row wrap" fxLayoutGap="15px">
                    @for (
                      service of getFavoriteServices() | filter: searchText;
                      track service
                    ) {
                      <div class="app-card mini">
                        <div class="image-description">
                          <div fxFlex="40">
                            @if (service.jpegPhoto !== '') {
                              <img
                                [src]="
                                  service.jpegPhoto.includes(
                                    '/assets/images/maintenance/services/'
                                  )
                                    ? service.jpegPhoto
                                    : 'data:image/png;base64,' +
                                      service.jpegPhoto
                                "
                                class="serviceImage_mini"
                                alt="Image du service" />
                            } @else {
                              <img
                                src="../../../assets/images/cards/noimage.png"
                                class="serviceImage_mini"
                                alt="Image vide" />
                            }
                          </div>
                          <div class="favorite-menu-mini">
                            <div fxFlex></div>
                            <!-- Spacer to push the image to the right -->
                            @if (
                              service.subtype.includes('pedagogique-edulog')
                            ) {
                              <div fxLayoutAlign="end center">
                                <img
                                  [src]="
                                    '../../../assets/images/cards/edulog.png'
                                  "
                                  class="image-edulog_mini"
                                  alt="{{
                                    'GENERAL.SERVICE_IMAGE' | translate
                                  }}" />
                              </div>
                            }
                            <button mat-icon-button [matMenuTriggerFor]="menu">
                              <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                              <button
                                mat-menu-item
                                (click)="removeTag(service)">
                                <span>{{
                                  'DASHBOARD.REMOVEFAVORITE' | translate
                                }}</span>
                                <mat-icon>star_border</mat-icon>
                              </button>
                            </mat-menu>
                          </div>
                          <div fxFlex="60">
                            <div class="mini-card-title">
                              {{ service.title }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="action-mini"
                          fxLayout="row"
                          fxLayoutAlign="start center">
                          <button
                            mat-button
                            color="accent"
                            class="access-btn"
                            (click)="openService(service)">
                            {{ 'GENERAL.ACCESS' | translate }}
                          </button>
                          @if (service.help !== '') {
                            <button
                              mat-button
                              color="accent"
                              (click)="openDocumentation(service)">
                              <mat-icon mat-list-icon>help_outline</mat-icon>
                            </button>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </mat-card>
            }
            @if (getOtherServices().length >= 1) {
              <mat-card
                class="card-container"
                [ngClass]="{
                  'no-favourites':
                    getFavoriteServices().length === 0 &&
                    getHiddenServices().length === 0 &&
                    getOtherServices().length >= 1,
                }">
                @if (
                  (getFavoriteServices().length >= 1 ||
                    getHiddenServices().length >= 1) &&
                  getOtherServices().length >= 1
                ) {
                  <h2 class="expand-hidden">
                    {{ 'DASHBOARD.OTHERS' | translate }}
                  </h2>
                }
                @if (display === 0) {
                  <div fxLayout="row wrap" fxLayoutGap="15px">
                    @for (
                      service of getOtherServices() | filter: searchText;
                      track service
                    ) {
                      <div class="app-card">
                        <div
                          class="image-description"
                          fxLayoutAlign="left center">
                          <div fxFlex="100">
                            @if (service.jpegPhoto !== '') {
                              <img
                                [src]="
                                  service.jpegPhoto.includes(
                                    '/assets/images/maintenance/services/'
                                  )
                                    ? service.jpegPhoto
                                    : 'data:image/png;base64,' +
                                      service.jpegPhoto
                                "
                                class="serviceImage"
                                alt="{{
                                  'GENERAL.SERVICE_IMAGE' | translate
                                }}" />
                            } @else {
                              <img
                                src="../../../assets/images/cards/noimage.png"
                                class="serviceImage"
                                alt="{{ 'GENERAL.EMPTY_IMAGE' | translate }}" />
                            }
                          </div>
                        </div>
                        <div class="favorite-menu-maxi">
                          <button mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                          </button>
                          <mat-menu #menu="matMenu">
                            <button
                              mat-menu-item
                              (click)="addFavorite(service)">
                              <span>{{
                                'DASHBOARD.ADDFAVORITE' | translate
                              }}</span>
                              <mat-icon>star_border</mat-icon>
                            </button>
                            <button mat-menu-item (click)="addHidden(service)">
                              <span>{{ 'DASHBOARD.HIDE' | translate }}</span>
                              <mat-icon>visibility_off</mat-icon>
                            </button>
                          </mat-menu>
                        </div>
                        <div>
                          <div class="title-container">
                            <div class="title">{{ service.title }}</div>
                            <div class="subtitle secondary-text">
                              {{ service.subtitle }}
                            </div>
                          </div>
                          <div class="description">
                            <div class="serviceDesc" fxFlex="100">
                              {{ service.description }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="action"
                          fxLayout="row"
                          fxLayoutAlign="start center">
                          <button
                            mat-button
                            color="accent"
                            class="access-btn"
                            (click)="openService(service)">
                            {{ 'GENERAL.ACCESS' | translate }}
                          </button>
                          @if (service.help !== '') {
                            <button
                              mat-button
                              color="accent"
                              (click)="openDocumentation(service)">
                              <mat-icon mat-list-icon>help_outline</mat-icon>
                            </button>
                          }
                          <div fxFlex></div>
                          <!-- Spacer to push the image to the right -->
                          @if (service.subtype.includes('pedagogique-edulog')) {
                            <div fxLayoutAlign="end center">
                              <img
                                [src]="
                                  '../../../assets/images/cards/edulog.png'
                                "
                                class="image-edulog"
                                alt="{{
                                  'GENERAL.SERVICE_IMAGE' | translate
                                }}" />
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (display === 1) {
                  <div fxLayout="row wrap" fxLayoutGap="15px">
                    @for (
                      service of getOtherServices() | filter: searchText;
                      track service
                    ) {
                      <div class="app-card mini">
                        <div class="image-description">
                          <div fxFlex="40">
                            @if (service.jpegPhoto !== '') {
                              <img
                                [src]="
                                  service.jpegPhoto.includes(
                                    '/assets/images/maintenance/services/'
                                  )
                                    ? service.jpegPhoto
                                    : 'data:image/png;base64,' +
                                      service.jpegPhoto
                                "
                                class="serviceImage_mini"
                                alt="Image du service" />
                            } @else {
                              <img
                                src="../../../assets/images/cards/noimage.png"
                                class="serviceImage_mini"
                                alt="Image vide" />
                            }
                          </div>
                          <div class="favorite-menu-mini">
                            <div fxFlex></div>
                            <!-- Spacer to push the image to the right -->
                            @if (
                              service.subtype.includes('pedagogique-edulog')
                            ) {
                              <div fxLayoutAlign="end center">
                                <img
                                  [src]="
                                    '../../../assets/images/cards/edulog.png'
                                  "
                                  class="image-edulog_mini"
                                  alt="{{
                                    'GENERAL.SERVICE_IMAGE' | translate
                                  }}" />
                              </div>
                            }
                            <button mat-icon-button [matMenuTriggerFor]="menu">
                              <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                              <button
                                mat-menu-item
                                (click)="addFavorite(service)">
                                <span>{{
                                  'DASHBOARD.ADDFAVORITE' | translate
                                }}</span>
                                <mat-icon>star_border</mat-icon>
                              </button>
                              <button
                                mat-menu-item
                                (click)="addHidden(service)">
                                <span>{{ 'DASHBOARD.HIDE' | translate }}</span>
                                <mat-icon>visibility_off</mat-icon>
                              </button>
                            </mat-menu>
                          </div>
                          <div fxFlex="60">
                            <div class="mini-card-title">
                              {{ service.title }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="action-mini"
                          fxLayout="row"
                          fxLayoutAlign="start center">
                          <button
                            mat-button
                            color="accent"
                            class="access-btn"
                            (click)="openService(service)">
                            {{ 'GENERAL.ACCESS' | translate }}
                          </button>
                          @if (service.help !== '') {
                            <button
                              mat-button
                              color="accent"
                              (click)="openDocumentation(service)">
                              <mat-icon mat-list-icon>help_outline</mat-icon>
                            </button>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </mat-card>
            }
            @if (getHiddenServices().length >= 1) {
              <mat-card class="card-container">
                <h2
                  class="expand-hidden card-title"
                  (click)="toggleVisibilityHiddenServices()"
                  (keydown.enter)="toggleVisibilityHiddenServices()"
                  (keydown.space)="toggleVisibilityHiddenServices()"
                  role="button"
                  tabindex="0">
                  {{ 'DASHBOARD.HIDDEN' | translate }}
                  @if (showHiddenServices) {
                    <mat-icon class="icon-expand">expand_less</mat-icon>
                  }
                  @if (!showHiddenServices) {
                    <mat-icon class="icon-expand">expand_more</mat-icon>
                  }
                </h2>
                @if (showHiddenServices) {
                  <div>
                    @if (display === 0) {
                      <div fxLayout="row wrap" fxLayoutGap="15px">
                        @for (
                          service of getHiddenServices() | filter: searchText;
                          track service
                        ) {
                          <div class="app-card">
                            <div
                              class="image-description"
                              fxLayoutAlign="left center">
                              <div fxFlex="100">
                                @if (service.jpegPhoto !== '') {
                                  <img
                                    [src]="
                                      service.jpegPhoto.includes(
                                        '/assets/images/maintenance/services/'
                                      )
                                        ? service.jpegPhoto
                                        : 'data:image/png;base64,' +
                                          service.jpegPhoto
                                    "
                                    class="serviceImage"
                                    alt="Image du service" />
                                } @else {
                                  <img
                                    src="../../../assets/images/cards/noimage.png"
                                    class="serviceImage"
                                    alt="Image vide" />
                                }
                              </div>
                            </div>
                            <div class="favorite-menu-maxi">
                              <button
                                mat-icon-button
                                [matMenuTriggerFor]="menu">
                                <mat-icon>more_vert</mat-icon>
                              </button>
                              <mat-menu #menu="matMenu">
                                <button
                                  mat-menu-item
                                  (click)="removeTag(service)">
                                  <span>{{
                                    'DASHBOARD.SHOW' | translate
                                  }}</span>
                                  <mat-icon>visibility</mat-icon>
                                </button>
                              </mat-menu>
                            </div>
                            <div>
                              <div class="title-container">
                                <div class="title">{{ service.title }}</div>
                                <div class="subtitle secondary-text">
                                  {{ service.subtitle }}
                                </div>
                              </div>
                              <div class="description">
                                <div class="serviceDesc" fxFlex="100">
                                  {{ service.description }}
                                </div>
                              </div>
                            </div>
                            <div
                              class="action"
                              fxLayout="row"
                              fxLayoutAlign="start center">
                              <button
                                mat-button
                                color="accent"
                                class="access-btn"
                                (click)="openService(service)">
                                {{ 'GENERAL.ACCESS' | translate }}
                              </button>
                              @if (service.help !== '') {
                                <button
                                  mat-button
                                  color="accent"
                                  (click)="openDocumentation(service)">
                                  <mat-icon mat-list-icon
                                    >help_outline</mat-icon
                                  >
                                </button>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    }
                    @if (display === 1) {
                      <div fxLayout="row wrap" fxLayoutGap="15px">
                        @for (
                          service of getHiddenServices() | filter: searchText;
                          track service
                        ) {
                          <div class="app-card mini">
                            <div class="image-description">
                              <div fxFlex="40">
                                @if (service.jpegPhoto !== '') {
                                  <img
                                    [src]="
                                      service.jpegPhoto.includes(
                                        '/assets/images/maintenance/services/'
                                      )
                                        ? service.jpegPhoto
                                        : 'data:image/png;base64,' +
                                          service.jpegPhoto
                                    "
                                    class="serviceImage_mini"
                                    alt="Image du service" />
                                } @else {
                                  <img
                                    src="../../../assets/images/cards/noimage.png"
                                    class="serviceImage_mini"
                                    alt="Image vide" />
                                }
                              </div>
                              <div class="favorite-menu-mini">
                                <button
                                  mat-icon-button
                                  [matMenuTriggerFor]="menu">
                                  <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                  <button
                                    mat-menu-item
                                    (click)="removeTag(service)">
                                    <span>{{
                                      'DASHBOARD.SHOW' | translate
                                    }}</span>
                                    <mat-icon>visibility</mat-icon>
                                  </button>
                                </mat-menu>
                              </div>
                              <div fxFlex="60">
                                <div class="mini-card-title">
                                  {{ service.title }}
                                </div>
                              </div>
                            </div>
                            <div
                              class="action-mini"
                              fxLayout="row"
                              fxLayoutAlign="start center">
                              <button
                                mat-button
                                color="accent"
                                class="access-btn"
                                (click)="openService(service)">
                                {{ 'GENERAL.ACCESS' | translate }}
                              </button>
                              @if (service.help !== '') {
                                <button
                                  mat-button
                                  color="accent"
                                  (click)="openDocumentation(service)">
                                  <mat-icon mat-list-icon
                                    >help_outline</mat-icon
                                  >
                                </button>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </mat-card>
            }
          </div>
        }
        <div class="mat-elevation-z8">
          @if (display === 2) {
            <div fxLayoutGap="15px">
              <table
                mat-table
                [dataSource]="dataSource"
                matSort
                (matSortChange)="sortData($event)"
                multiTemplateDataRows>
                <ng-container matColumnDef="jpegPhoto">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'TABLE.SERVICES.HEADER.IMG' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    @if (element.jpegPhoto) {
                      <img
                        [src]="
                          element.jpegPhoto.includes(
                            '/assets/images/maintenance/services/'
                          )
                            ? element.jpegPhoto
                            : 'data:image/png;base64,' + element.jpegPhoto
                        "
                        class="serviceImageTable"
                        alt="{{ 'GENERAL.SERVICE_IMAGE' | translate }}" />
                    }
                    @if (!element.jpegPhoto) {
                      <img
                        src="../../../assets/images/cards/noimage.png"
                        class="serviceImageTable"
                        alt="{{ 'GENERAL.EMPTY_IMAGE' | translate }}" />
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="title">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header="title"
                    class="sortable">
                    {{ 'TABLE.SERVICES.HEADER.NAME' | translate }}
                    <mat-icon
                      [style.color]="
                        sortedValue !== 'title' ? '#757575' : 'transparent'
                      "
                      class="sort-icon"
                      >sort</mat-icon
                    >
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.title }}
                    @if (element.subtype.includes('pedagogique-edulog')) {
                      <img
                        [src]="'../../../assets/images/cards/edulog.png'"
                        alt="{{ 'GENERAL.SERVICE_IMAGE' | translate }}"
                        class="edulogImageTable"
                        style="vertical-align: middle; margin-left: 8px" />
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'TABLE.SERVICES.HEADER.DESCRIPTION' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.description }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="help">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'TABLE.SERVICES.HEADER.HELP' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    @if (element.help !== '') {
                      <button
                        mat-button
                        color="accent"
                        (click)="openDocumentation(element)">
                        <mat-icon mat-list-icon>help_outline</mat-icon>
                      </button>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="tagId">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'TABLE.SERVICES.HEADER.FAVORITE' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    @if (element.tagId === 0) {
                      <div class="notTaggedElementTable">
                        <button
                          class="button-favorite"
                          (click)="addFavorite(element)">
                          <mat-icon class="isNotFavorite">star_border</mat-icon>
                        </button>
                        <button
                          class="button-favorite"
                          (click)="addHidden(element)">
                          <mat-icon class="isNotFavorite"
                            >visibility_off</mat-icon
                          >
                        </button>
                      </div>
                    }
                    @if (element.tagId === 1) {
                      <button
                        class="button-favorite"
                        (click)="removeTag(element)">
                        <mat-icon class="isFavorite">star</mat-icon>
                      </button>
                    }
                    @if (element.tagId === 2) {
                      <button
                        class="button-favorite"
                        (click)="removeTag(element)">
                        <mat-icon class="isNotFavorite">visibility</mat-icon>
                      </button>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="accessurl">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'TABLE.SERVICES.HEADER.ACCESS' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <button
                      mat-button
                      color="accent"
                      class="access-btn"
                      (click)="openService(element)">
                      {{ 'GENERAL.ACCESS' | translate }}
                    </button>
                  </td>
                </ng-container>
                <ng-container matColumnDef="expand">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-icon-button (click)="toggleRow(element)">
                      <mat-icon>more_horiz</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <ng-container matColumnDef="expandedDetail">
                  <td
                    mat-cell
                    *matCellDef="let element"
                    [attr.colspan]="displayedColumns.length">
                    @if (expandedElement === element && windowWidth < 850) {
                      <div class="expanded-detail">
                        @if (windowWidth < 400) {
                          <p>
                            <strong
                              >{{
                                'TABLE.SERVICES.HEADER.IMG' | translate
                              }}:</strong
                            >
                            @if (element.jpegPhoto) {
                              <img
                                [src]="
                                  element.jpegPhoto.includes(
                                    '/assets/images/maintenance/services/'
                                  )
                                    ? element.jpegPhoto
                                    : 'data:image/png;base64,' +
                                      element.jpegPhoto
                                "
                                class="serviceImageTable"
                                alt="{{
                                  'GENERAL.SERVICE_IMAGE' | translate
                                }}" />
                            }
                            @if (!element.jpegPhoto) {
                              <img
                                src="../../../assets/images/cards/noimage.png"
                                class="serviceImageTable"
                                alt="{{ 'GENERAL.EMPTY_IMAGE' | translate }}" />
                            }
                          </p>
                        }
                        <p>
                          <strong
                            >{{
                              'TABLE.SERVICES.HEADER.DESCRIPTION' | translate
                            }}:</strong
                          >
                          {{ element.description }}
                        </p>
                        @if (element.help !== '' && windowWidth < 650) {
                          <p>
                            <strong
                              >{{
                                'TABLE.SERVICES.HEADER.HELP' | translate
                              }}:</strong
                            >
                            <button
                              mat-button
                              color="accent"
                              (click)="openDocumentation(element)">
                              <mat-icon mat-list-icon>help_outline</mat-icon>
                            </button>
                          </p>
                        }
                        @if (windowWidth < 550) {
                          <p>
                            <strong
                              >{{
                                'TABLE.SERVICES.HEADER.FAVORITE' | translate
                              }}:
                            </strong>
                            @if (element.tagId === 0) {
                              <button
                                class="button-favorite"
                                (click)="addFavorite(element)">
                                <mat-icon class="isNotFavorite"
                                  >star_border</mat-icon
                                >
                              </button>
                            }
                            @if (element.tagId === 0) {
                              <button
                                class="button-favorite"
                                (click)="addHidden(element)">
                                <mat-icon class="isNotFavorite"
                                  >visibility_off</mat-icon
                                >
                              </button>
                            }
                            @if (element.tagId === 1) {
                              <button
                                class="button-favorite"
                                (click)="removeTag(element)">
                                <mat-icon class="isFavorite">star</mat-icon>
                              </button>
                            }
                            @if (element.tagId === 2) {
                              <button
                                class="button-favorite"
                                (click)="removeTag(element)">
                                <mat-icon class="isNotFavorite"
                                  >visibility</mat-icon
                                >
                              </button>
                            }
                          </p>
                        }
                      </div>
                    }
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="
                    let row;
                    let index = dataIndex;
                    columns: displayedColumns
                  "
                  class="element-row"
                  [style.background]="
                    row.tagId === 2
                      ? 'repeating-linear-gradient(45deg, rgba(160, 160, 160, 0.2), rgba(160, 160, 160, 0.2) 2px, white 2px, white 10px)'
                      : ''
                  "
                  [ngClass]="{ alternate: index % 2 === 0 }"></tr>
                <tr
                  mat-row
                  *matRowDef="
                    let row;
                    let index = dataIndex;
                    columns: ['expandedDetail']
                  "
                  class="detail-row"
                  [style.background]="
                    row.tagId === 2
                      ? 'repeating-linear-gradient(45deg, rgba(160, 160, 160, 0.2), rgba(160, 160, 160, 0.2) 2px, white 2px, white 10px)'
                      : ''
                  "
                  [ngClass]="{ alternate: index % 2 === 0 }"></tr>
              </table>
            </div>
          }
          <mat-paginator
            [style.display]="display === 2 ? 'block' : 'none'"
            [hidePageSize]="true"
            [pageSize]="10"
            showFirstLastButtons>
          </mat-paginator>
        </div>
        @if (
          (!isLoading && filterServicesTranslated.length === 0) || !selectedUser
        ) {
          <div class="content" fxLayout="row wrap" fxLayoutGap="1rem">
            <div
              id="error-noservice"
              fxLayout="column"
              fxLayoutAlign="center center">
              <div
                class="content"
                fxLayout="column"
                fxLayoutAlign="center center">
                <div class="error-code">
                  {{ 'ERROR.NOSERVICE' | translate }}
                </div>
                <div class="message">
                  {{ 'ERROR.NOSERVICEDESC' | translate }}
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
  <!-- /CONTENT -->
</div>
